import { ServerErrorCode, SLIDE_ERROR_VALUES } from './error-code';
import { RoomErrorCode, RoomWebsocketErrorCode } from './room-error-code';

export * from './error-code';

export enum WaitAcceptCmd {
    AcceptCommit = 'ACCEPT_COMMIT',
    CommitError = 'COMMIT_ERROR',
    TaskDuplicate = 'TASK_DUPLICATE',
}

export enum ErrorSource {
    // 房间层错误
    Room = 'room',
    // 服务端错误
    Server = 'server',
}

export enum RetrySource {
    Block = 'block',
    RoomError = 'roomError',
    CommitError = 'commitError',
}

export const REASON_FOR_CONNECT_MODE = [RoomWebsocketErrorCode.SOCKET_SWITCH_BIG_COLLAB];
export const REASON_FOR_NEED_FETCH = [
    RoomWebsocketErrorCode.SOCKET_DATA_BASEREV_ERROR,
    RoomWebsocketErrorCode.SOCKET_DATA_REV_DIFF_UPPER_TEN,
    ServerErrorCode.COMMIT_ERROR_BASEREV_LIMIT_ERROR,
];
export const REASON_FOR_RETRY = [
    RoomWebsocketErrorCode.SOCKET_DATA_SAVE_FAIL,
    RoomWebsocketErrorCode.SOCKET_HACKPAD_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_SEND_MESSAGE_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_COLLAB_ROOM_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_COLLAB_SERVER_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_SERVER_STORAGE_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_SERVER_CGI_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_FREQUENCY_LIMIT,
    RoomWebsocketErrorCode.SOCKET_SERVER_WAITTING_TOO_LONG,
    RoomWebsocketErrorCode.SOCKET_SERVER_WAITTING_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_AUTH_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_GET_PRIVILEGE_TIMEOUT,
];
export const REASON_FOR_FATAL_ERROR = [
    RoomWebsocketErrorCode.SOCKET_DATA_SERVER_UNKNOWN_ERROR,
    RoomWebsocketErrorCode.SOCKET_DATA_PROTOCOL_FIELD_LACK,
    RoomWebsocketErrorCode.SOCKET_DATA_SERVER_ERROR,
    RoomWebsocketErrorCode.SOCKET_DATA_DOC_NOT_EXIST,
    RoomWebsocketErrorCode.SOCKET_DATA_SUBID_ERROR,
    RoomWebsocketErrorCode.SOCKET_DATA_ACTION_LENGTH,
    RoomWebsocketErrorCode.SOCKET_DATA_READ_FAIL,
    RoomWebsocketErrorCode.SOCKET_DATA_NOT_SUPPORTED_TYPE,
    RoomWebsocketErrorCode.SOCKET_DATA_NOT_SUPPORTED_PROTO,
    RoomWebsocketErrorCode.SOCKET_DOCUMENT_EDIT_COLLAB_LIMIT,
    RoomWebsocketErrorCode.SOCKET_DATA_DOCID_ERROR,
    RoomWebsocketErrorCode.SOCKET_DATA_EASYSYNC_TIMEOUT,
    RoomWebsocketErrorCode.SOCKET_DATA_PROTOCOL_TYPE_ERROR,
    RoomWebsocketErrorCode.SOCKET_USER_CHANGE_PARAM_ERROR,
    RoomWebsocketErrorCode.SOCKET_COLLABROOM_DOC_DELETED,

    ServerErrorCode.INVALID_COMMIT_ATTRS,
    ServerErrorCode.APPLY_REVISION_CGO,
    ServerErrorCode.CGO_TRANSFORM,
    ...SLIDE_ERROR_VALUES,
];
export const REASON_FOR_NO_PRIVILEGE = [
    ServerErrorCode.COMMIT_NO_AUTH,
    RoomWebsocketErrorCode.SOCKET_USER_AUTH_FAILED,
    RoomWebsocketErrorCode.SOCKET_DOC_PRIVILEGE_FAILED,
    RoomWebsocketErrorCode.SOCKET_USER_DOC_NOPRIVILEGE,
    RoomWebsocketErrorCode.LOGIN_INVALIDATE,
    RoomWebsocketErrorCode.LOGIN_FORBIDDEN,
    RoomWebsocketErrorCode.SOCKET_IP_BLACK_LIST,
    RoomWebsocketErrorCode.SOCKET_USER_BLACK_LIST,
    RoomWebsocketErrorCode.SOCKET_DOCMENT_BLACK_LIST,
    RoomWebsocketErrorCode.SOCKET_USERAGENT_BLACK_LIST,
    ServerErrorCode.META_DATA_NOT_EXIST,
];
export const REASON_FOR_SIZE_TOO_LARGE = [
    RoomWebsocketErrorCode.SOCKET_DATA_CONTENT_LIMIT,
    RoomWebsocketErrorCode.SOCKET_PACKAGE_SIZE_TOO_LARGE,
    ServerErrorCode.OVERSIZE_COMMIT,
];
export const REASON_FOR_KICK_OUT = [RoomWebsocketErrorCode.INACTIVE, RoomWebsocketErrorCode.CODEREV_NEW];
export const REASON_FOR_ROOM = Object.values(RoomErrorCode).filter((v) => typeof v === 'number' && v !== 0);
